import { render } from "./BlogPageMenu.vue?vue&type=template&id=2f0d2e14&scoped=true"
import script from "./BlogPageMenu.vue?vue&type=script&lang=js"
export * from "./BlogPageMenu.vue?vue&type=script&lang=js"

import "./BlogPageMenu.vue?vue&type=style&index=0&id=2f0d2e14&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2f0d2e14"]])

export default __exports__